import Typography from "@portal/components/atoms/v2/typography";
import { useCallback, useState } from "react";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import Button from "@portal/components/atoms/v2/buttons/button";
import { ISavingsFooterProps } from "../types";
import Checkbox from "@portal/components/atoms/v2/checkbox";

export const Footer = ({ router, isDefaultLanguage, onClick, isLoading }: ISavingsFooterProps) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  const [confirmSaving, setConfirmSaving] = useState(false);
  const OnConfirmSaving = useCallback(() => {
    setConfirmSaving(!confirmSaving);
  }, [confirmSaving]);

  const OnSecondaryButtonClick = useCallback(() => {
    router.push(`/robot/16`);
  }, [router]);

  return (
    <div className="flex flex-col mt-3 mb-5">
      <Typography variant="Bold">{texts.PAGE_17_FOOTER_HEADER}</Typography>
      <Typography>{texts.PAGE_17_FOOTER_TEXT}</Typography>
      <Typography>{texts.PAGE_17_FOOTER_TEXT_2}</Typography>

      <div className="mt-4">
        <Checkbox id="confirm" text={texts.PAGE_17_CONFIRM} isChecked={confirmSaving} onChange={OnConfirmSaving} large />
      </div>
      <div className="mt-2">
        <Typography>{texts.PAGE_17_CONFIRM_INFO}</Typography>
      </div>

      <div className="flex  mt-5 justify-between">
        <Button onClick={OnSecondaryButtonClick} text={texts.BUTTON_BACK} />
        <Button
          loading={isLoading ? 1 : 0}
          onClick={onClick}
          text={isLoading ? "" : texts.BUTTON_COMPLETE_SAVING}
          disabled={!confirmSaving}
          primary
          wide
        />
      </div>
    </div>
  );
};
